<template>
  <div class="cc-edit-contact">
    <div v-if="showError" class="cc-edit-contact-erro">
      <h2>{{ t('consultantCorner.editContact.PageLoadError') }}</h2>
    </div>
    <div v-else>
      <!-- Header Section -->
      <div class="contact-header">
        <div class="first">
            <button class="cc-back-button" @click="goBack()">
          ← {{ t('consultantCorner.Back') }}
          </button>
          <div class="contact-title">{{ t('consultantCorner.editContact.EditContact') }}</div>
          <div class="contact-subtitle mb-1">{{ t('consultantCorner.editContact.EditContactDetails') }}</div>
        </div>
        <div class="contact-buttons">
        <button
          id="btnCancel"
          class="baseBtn secondaryBtn"
          type="button"
          @click="goBack()"
        >
          {{ t('consultantCorner.editContact.CancelButton') }}
        </button>
         <button
          id="btnSaveTrigger"
          class="baseBtn primaryBtn"
          type="submit"
          @click="saveTrigger($event)"
        >
          {{ t('consultantCorner.editContact.SaveButton') }}
        </button>
        </div>
      </div>
      <!-- Mobile Tab Dropdown (shown only on mobile) -->
      <div class="mobile-tab-dropdown">
        <label for="mobile-tab-select">{{ t('consultantCorner.editContact.SelectTab') }}</label>
        <select
          id="mobile-tab-select"
          v-model="selectedTab"
          @change="onMobileTabChange($event)"
          class="form-control"
        >
          <option
            v-for="(tab, index) in tabs"
            :key="index"
            :value="index"
          >
            {{ tab.title }}
          </option>
        </select>
      </div>
      <!-- Desktop Tab Strip (hidden on mobile) -->
      <kTabStrip
        :selected="selectedTab"
        @select="onSelectHandler($event)"
        :tabs="tabs"
        class="contact-tabs mt-3 "
      >
        <!-- General Tab -->
        <template v-slot:GeneralContent>
          <div class="tab-content-wrapper">
            <div class="contact-details-div">
              <div class="contact-details-content">
                <kForm
                  :initialValues="formInitialValues"
                  :key="JSON.stringify(formInitialValues)"
                  ref="myFormGeneral"
                  id="myForm"
                  @submitclick="onSubmitClickHandler($event)"
                >
                  <kformelement>
                    <div class="stepInfo stepOne">
                      <fieldset class="k-form-fieldset">
                        <div class="row">
                          <div class="col-12 col-lg-8 address">
                            <div class="row">
                              <div class="col-12 contact-edit-header">
                                {{ t('consultantCorner.editContact.ShippingAddress') }}
                              </div>
                            </div>
                            <hr>
                              <div class="row mt-2">
                                <div class="col-12 d-md-flex">
                                 <div class="namelabel col-md-3 mb-2 mb-md-0">
                                    {{ t('consultantCorner.addContact.firstName') }}
                                    <span class="required">*</span>
                                    <span class="sr-only">{{ t('accessibility.required') }}</span>
                                  </div>
                                  <ApplicationField
                                    columnName="firstName"
                                    :validators="firstNameValidator"
                                    :addAsterisk="true"
                                    :keyField="false"
                                  ></ApplicationField>
                                  <ApplicationField
                                  columnName="lastName"
                                  :validators="lastNameValidator"
                                  :addAsterisk="true"
                                  :keyField="false"
                                ></ApplicationField>
                                </div>
                              </div>
                            <div class="row d-none">
                              <div class="col-12">
                                <div class="namelabel mb-2">{{ t('consultantCorner.addContact.lastName') }}</div>
                              </div>
                            </div>
                            <div class="row mt-2">
                              <div class="col-12 d-md-flex">
                                <div class="namelabel col-md-3 mb-2 mb-md-0">{{ t('consultantCorner.addContact.preferredName') }}</div>
                                <ApplicationField
                                  columnName="preferredName"
                                  :keyField="false"
                                ></ApplicationField>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12">
                                <div class="address-control-wrapper">
                                  <AddressControl
                                    ref="shippingAddressControl"
                                    :countryCode="countryCode"
                                    :addressLine1="addressLine1Text"
                                    :addressLine2="addressLine2Text"
                                    :houseNumber="houseNumberText"
                                    :city="cityText"
                                    :stateCode="stateText"
                                    :postalCode="postalCodeText"
                                    :columnClass="'col-12 col-md-9'"
                                    :showfullnamefield="false"
                                    :isrequired="true"
                                    :hidecountrypicker="false"
                                    :isdisabled="false"
                                    :name="addressFirstNameText + ' ' + addressLastNameText"
                                    @address-change="addressControlUpdateHandler">
                                  </AddressControl>
                                </div>
                              </div>
                            </div>
                            </div>
                          <div class="col-12 col-lg-8 address">
                            <div class="row">
                              <div class="col-12 contact-edit-header">
                                {{ t('consultantCorner.editContact.BillingAddress') }}
                              </div>
                            </div>
                            <hr>
                            <div class="row mt-3">
                              <div class="col-12">
                                <KCheckBox
                                  class="chbx-same-as-shipping"
                                  :checked="sameAsShipping != null ? sameAsShipping : false"
                                  :label="t('consultantCorner.editContact.SameAsShipping')"
                                  @change="sameAsShippingCheckboxHandler($event)"
                                >
                                </KCheckBox>
                              </div>
                            </div>
                            <div v-if="!sameAsShipping" class="shippingaddress">
                            <div class="row mt-2">
                              <div class="col-12 d-md-flex">
                                <div class="namelabel col-md-3 mb-2 mb-md-0">{{ t('consultantCorner.editContact.Name') }}</div>
                                <ApplicationField
                                  columnName="billingFirstName"
                                  :disabled="sameAsShipping"
                                  :keyField="false"
                                ></ApplicationField>
                                <ApplicationField
                                  columnName="billingLastName"
                                  :disabled="sameAsShipping"
                                  :keyField="false"
                                ></ApplicationField>
                              </div>
                            </div>
                            <div class="row d-none">
                              <div class="d-flex">
                                <div class="namelabel">{{ t('consultantCorner.editContact.LastName') }}</div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12">
                                <div class="address-control-wrapper">
                                  <AddressControl
                                    ref="billingAddressControl"
                                    :countryCode="billingCountryCode"
                                    :addressLine1="billingAddressLine1Text"
                                    :addressLine2="billingAddressLine2Text"
                                    :houseNumber="billingHouseNumberText"
                                    :city="billingCityText"
                                    :stateCode="billingStateText"
                                    :postalCode="billingPostalCodeText"
                                    :isrequired="true"
                                    :columnClass="'col-12 col-md-9'"
                                    :showfullnamefield="false"
                                    :hidecountrypicker="false"
                                    :name="billingFirstNameRef + ' ' + billingLastNameRef"
                                    :isdisabled="sameAsShipping"
                                    @address-change="billingAddressControlUpdateHandler">
                                  </AddressControl>
                                </div>
                              </div>
                            </div>
                              </div>
                          </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-12 contact-edit-header">
                              {{ t('consultantCorner.editContact.Communication') }}
                            </div>
                          </div>
                          <hr>
                          <div class="row mt-2">
                            <div class="col-12 d-md-flex">
                              <div class="namelabel col-md-3 mb-2 mb-md-0">{{ t('consultantCorner.editContact.Email') }}</div>
                              <ApplicationField
                                id="txtEmailAddress"
                                columnName="emailAddress"
                                :validators="emailValidator"
                                :addAsterisk="true"
                                :keyField="false"
                                :disabled="hasNoEmail"
                              ></ApplicationField>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <KCheckBox
                                class="chbx-no-email"
                                :modelValue="hasNoEmail"
                                :label="t('consultantCorner.editContact.NoEmail')"
                                @change="noEmailCheckboxHandler($event)"
                              >
                              </KCheckBox>
                            </div>
                          </div>
                          <hr>
                          <div class="row pt-2">
                            <div class="col-12 col-md-3">
                              <div class="phone-label">{{ t('consultantCorner.editContact.PrimaryPhone') }} <span class="required">*</span><span class="sr-only">{{ t('accessibility.required') }}</span></div>
                            </div>
                            <div class="col-12 col-md-9">
                              <PhoneInputControl
                                ref="primaryPhoneControl"
                                v-model="primaryPhoneModel"
                                :required="true"
                                :showExtension="false"
                                :countryList="countries"
                                @change="onPrimaryPhoneChange"
                              />
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 col-md-3">
                              <div class="phone-label">{{ t('consultantCorner.editContact.AltPhone') }}</div>
                            </div>
                            <div class="col-12 col-md-9">
                              <PhoneInputControl
                                v-model="alt1PhoneModel"
                                :required="false"
                                :showExtension="false"
                                :countryList="countries"
                                @change="onAlt1PhoneChange"
                              />
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 col-md-3">
                              <div class="phone-label">{{ t('consultantCorner.editContact.AltPhone') }}</div>
                            </div>
                            <div class="col-12 col-md-9">
                              <PhoneInputControl
                                v-model="alt2PhoneModel"
                                :required="false"
                                :showExtension="false"
                                :countryList="countries"
                                @change="onAlt2PhoneChange"
                              />
                            </div>
                          </div>
                      </fieldset>
                    </div>
                    <button
                        id="btnSave"
                        class="hiddenButton"
                        type="submit">
                    </button>
                  </kformelement>
                </kForm>
              </div>
            </div>
          </div>
        </template>
        <!-- Lead Tab -->
        <template v-slot:LeadContent>
          <div class="tab-content-wrapper">
            <div v-if="isLoadingLeads" class="text-center p-4">
              <p>{{ t('labels.Loading') }}</p>
            </div>
            <div v-else-if="leadError" class="text-center p-4">
              <p class="text-danger">{{ t('consultantCorner.common.ErrorLoadingData') }}</p>
            </div>
            <div v-else-if="leads.length === 0" class="text-center p-4">
              <p>{{ t('consultantCorner.leads.NoLeads') }}</p>
            </div>
            <div v-else class="lead-content p-4">
              <div class="lead-card">
                <h4 class="mb-4">{{ leads[0].firstName }} {{ leads[0].lastName }}</h4>
                <div class="row mb-3">
                  <div class="col-md-6">
                    <div class="lead-field">
                      <div class="lead-label">{{ t('consultantCorner.leads.LeadType') }}</div>
                      <div class="lead-value">{{ leads[0].sfaLeadTypeId || '-' }}</div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="lead-field">
                      <div class="lead-label">{{ t('consultantCorner.leads.DistSource') }}</div>
                      <div class="lead-value">{{ leads[0].leadDistSource || '-' }}</div>
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-6">
                    <div class="lead-field">
                      <div class="lead-label">{{ t('consultantCorner.leads.CreateDate') }}</div>
                      <div class="lead-value">{{ formatDate(leads[0].createDate) || '-' }}</div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="lead-field">
                      <div class="lead-label">{{ t('consultantCorner.leads.AssignedDate') }}</div>
                      <div class="lead-value">{{ formatDate(leads[0].assignedDate) || '-' }}</div>
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-6">
                    <div class="lead-field">
                      <div class="lead-label">{{ t('consultantCorner.common.Email') }}</div>
                      <div class="lead-value">{{ leads[0].emailAddress || '-' }}</div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="lead-field">
                      <div class="lead-label">{{ t('consultantCorner.common.Phone') }}</div>
                      <div class="lead-value">{{ leads[0].primaryPhone || '-' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- Tasks Tab -->
        <template v-slot:Tasks>
          <div class="tab-content-wrapper">
            <p>{{ t('consultantCorner.tabs.TasksContent') }}</p>
          </div>
        </template>
        <!-- Notes Tab -->
        <template v-slot:NotesContent>
          <div class="tab-content-wrapper">
            <div class="contact-details-div">
              <div class="contact-details-content">
                <div class="row notes-editor-div">
                  <div class="col-12">
                    <TextArea
                      class="note-textarea"
                      v-model="editorRef"
                      :rows="4"
                      />
                    </div>
                  </div>
                <div class="row notes-editor-div">
                  <div class="col-12">
                    <button type="button" class="baseBtn primaryBtn" @click="addNotes">{{ t('consultantCorner.editContact.AddNotes') }}</button>
                  </div>
                </div>
                <div v-for="note in addressBookNotes" :key="note.beeAddressBookNoteGuid ? note.beeAddressBookNoteGuid : note.beeAddressBookTeamNoteGuid ? note.beeAddressBookTeamNoteGuid : 0" class="notes-list-div">
                  <div class="note-div mt-3">
                    <div class="row">
                      <div class="col-12 note-date">
                        {{ note.noteDate ? formatDate(note.noteDate.toString()) : '' }}
                      </div>
                    </div>
                    <hr>
                    <div class="row">
                      <div class="col-12 note-text">
                        {{ note.noteText }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- Orders Tab -->
        <template v-slot:OrdersContent>
          <div class="tab-content-wrapper">
            <div class="order-header-container">
              <h3 class="order-summary-title">{{t('consultantCorner.editContact.OrderSummary')}}</h3>
              <div class="order-buttons">
                <button type="button" class="baseBtn primaryBtn view-orders-btn" @click="viewOrders">{{t('consultantCorner.editContact.ViewOrders')}}</button>
                <button type="button" class="baseBtn secondaryBtn create-order-btn"  @click="createOrder">{{t('consultantCorner.editContact.Order')}}</button>
              </div>
            </div>
            <Grid
              ref="grid"
              class="order-grid mt-3"
              :data-items="sortedGridData"
              :resizable="true"
              :sortable="true"
              :sort="sort"
              :pageable="false"
              :columns="columns"
              @sortchange="sortChangeHandler"
              :loader="loader"
            >
            <GridNoRecords>{{ t('kendo.grid.noOrdersAvailable') }}</GridNoRecords>
            <template v-slot:orderIdTemplate="{ props }">
              <td v-if="props.rowType !== 'groupHeader'" class="order-orderid-div">
                <a class=" base-hyper-link order-title-link" :href="finalOrderSummaryURL + '?id=' + props.dataItem.aoeOrderIdToken">{{ props.dataItem.aoeOrderId }}</a>
              </td>
            </template>
            <template v-slot:orderTotalTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'" class="text-end">
                  {{ FormatCurrency(props.dataItem.orderTotal, props.dataItem.currencyId) }}
                </td>
              </template>
            <template v-slot:orderDateTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'" class="text-center">
                  {{ formatDate(props.dataItem.orderTime) }}
                </td>
              </template>
              <template v-slot:eventDateTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'" class="text-center">
                  {{ props.dataItem.eventDate ? formatDate(props.dataItem.eventDate) : '' }}
                </td>
              </template>
              <template v-slot:eventIdTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'" class="eventTitleDiv">
                  <a v-if="props.dataItem.eventIdToken" class="event-title-link base-hyper-link" :href="eventManagementURL + props.dataItem.eventIdToken">{{ getEventDisplayText(props.dataItem) }}</a>
                  <span v-else-if="props.dataItem.eventId != null">{{ getEventDisplayText(props.dataItem) }}</span>
                </td>
              </template>
            </Grid>
            <div class="w-100 text-center mt-3" v-if="orderGridData.length === 0"><span>{{ t('consultantCorner.editContact.ClickViewOrders') }}</span></div>
          </div>
        </template>
        <!-- Activity Tab -->
        <template v-slot:Activity>
          <div class="tab-content-wrapper">
            <p>{{ t('consultantCorner.tabs.ActivityContent') }}</p>
          </div>
        </template>
        <!-- Additional Information Tab -->
        <template v-slot:AdditionalInformationContent>
          <div class="tab-content-wrapper">
            <div class="contact-details-div">
              <div class="contact-details-content">
                <kForm
                  :initialValues="addInfoFormInitialValues"
                  :key="JSON.stringify(addInfoFormInitialValues)"
                  ref="myFormAdditional"
                  id="myFormAdditional"
                  @submitclick="onSubmitInfoClickHandler($event)"
                >
                  <kformelement>
                    <div class="contact-edit-tab additional-info">
                      <fieldset class="k-form-fieldset">
                        <div class="row">
                          <div class="col-12 col-lg-6">
                            <div class="row">
                              <div class="col-12 contact-edit-header">
                                {{ t('consultantCorner.editContact.PersonalInformation') }}
                              </div>
                            </div>
                            <hr>
                            <div class="row">
                              <div class="col-12">
                                <ApplicationField
                                  columnName="companyName"
                                  :keyField="false"
                                ></ApplicationField>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12">
                                <ApplicationField
                                  columnName="title"
                                  :keyField="false"
                                ></ApplicationField>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 k-form-field">
                                <div class="k-form-field-wrap">
                                  <span class="k-floating-label-container">
                                    <DropDownList
                                      id="language"
                                      :data-items='languages'
                                      :value="selectedLanguage"
                                      :text-field="'text'"
                                      :data-item-key="'id'"
                                      @change="languageChangeHandler($event.target.value)">
                                    </DropDownList>
                                    <label for="language" class="k-floating-label">{{t('consultantCorner.editContact.Language')}}</label>
                                  </span>
                                  <div id="" class="k-form-hint k-text-start"></div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 k-form-field">
                                <div class="k-form-field-wrap">
                                  <LocalizationProvider :language="locale">
                                    <span class="k-floating-label-container">
                                      <span class="k-textbox k-input k-input-md k-input-solid k-rounded-md">
                                        <DatePicker
                                          id="birthDateTxt"
                                          v-model="txtBirthDate"
                                          @change="dateChangeHandler($event)"
                                          :format="dateFormat"
                                          :formatPlaceholder="formatPlaceholder">
                                        </DatePicker>
                                      </span>
                                      <label for="birthDateTxt" class="k-floating-label">{{t('consultantCorner.editContact.BirthDate')}}</label>
                                    </span>
                                  </LocalizationProvider>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="row">
                              <div class="col-12 contact-edit-header">
                                {{ t('consultantCorner.editContact.Misc') }}
                              </div>
                            </div>
                            <hr>
                            <div class="row">
                              <div class="col-12 k-form-field">
                                <div class="k-form-field-wrap">
                                  <span class="k-floating-label-container">
                                    <DropDownList
                                      id="group"
                                      :data-items='groups'
                                      :value="selectedGroup"
                                      :text-field="'text'"
                                      :data-item-key="'id'"
                                      @change="groupChangeHandler($event.target.value)">
                                    </DropDownList>
                                    <label for="group" class="k-floating-label">{{t('consultantCorner.editContact.Group')}}</label>
                                  </span>
                                  <div id="" class="k-form-hint k-text-start"></div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 k-form-field">
                                <div class="k-form-field-wrap">
                                  <span class="k-floating-label-container">
                                    <DropDownList
                                      id="referralSource"
                                      :data-items='referralSources'
                                      :value="selectedReferralSource"
                                      :text-field="'text'"
                                      :data-item-key="'id'"
                                      @change="referralSourceChangeHandler($event.target.value)">
                                    </DropDownList>
                                    <label for="referralSource" class="k-floating-label">{{t('consultantCorner.editContact.HowDidYouHear')}}</label>
                                  </span>
                                  <div id="" class="k-form-hint k-text-start"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <button
                          id="btnSaveAdditional"
                          class="hiddenButton"
                          type="submit">
                        </button>
                      </fieldset>
                    </div>
                  </kformelement>
                </kForm>
              </div>
            </div>
          </div>
        </template>
        <!-- Social Media Tab -->
        <template v-slot:SocialMediaContent>
          <div class="tab-content-wrapper">
            <div class="contact-details-div">
              <div class="contact-details-content">
                <kForm
                  :initialValues="socialMediaFormInitialValues"
                  :key="JSON.stringify(socialMediaFormInitialValues)"
                  ref="myFormSocialMedia"
                  id="myFormSocialMedia"
                  @submitclick="onSubmitSocialMediaClickHandler($event)"
                >
                  <kformelement>
                    <div class="social-media-div">
                      <fieldset class="k-form-fieldset">
                        <div class="row">
                          <div class="col-12">
                            <label>{{ t('columns.facebookId') }}</label>
                            <ApplicationField
                              columnName="facebookId"
                              :keyField="false"
                            ></ApplicationField>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <label>{{ t('columns.twitterId') }}</label>
                            <ApplicationField
                              columnName="twitterId"
                              :keyField="false"
                            ></ApplicationField>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <label>{{ t('columns.pinterestId') }}</label>
                            <ApplicationField
                              columnName="pinterestId"
                              :keyField="false"
                            ></ApplicationField>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <label>{{ t('columns.linkedInId') }}</label>
                            <ApplicationField
                              columnName="linkedInId"
                              :keyField="false"
                            ></ApplicationField>
                          </div>
                        </div>
                        <button
                          id="btnSaveSocialMedia"
                          class="hiddenButton"
                          type="submit">
                        </button>
                      </fieldset>
                    </div>
                  </kformelement>
                </kForm>
              </div>
            </div>
          </div>
        </template>
      </kTabStrip>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted, computed, onBeforeMount } from 'vue'
import { useI18n } from 'vue-i18n'
import { useLogger } from 'vue-logger-plugin'
import { useConsultantOwnEmailGuard } from '../../composables/useConsultantOwnEmailGuard'
import { TabStrip as kTabStrip, type TabStripSelectEventArguments } from '@progress/kendo-vue-layout'
import { Grid, GridNoRecords, type GridSortChangeEvent } from '@progress/kendo-vue-grid';
import {
  Form as kForm,
  FormElement as kformelement,
  type FormSubmitClickEvent
} from '@progress/kendo-vue-form'
import ApplicationField from '../../application/ApplicationField.vue'
import type { IAoeContact, IAoeContactUpdate, IAoeContactNote, IAoeContactOrder, IAoeContactInfo, IAoeContactSocials } from '../../types/AddressBookTypes'
import type { IAddress, IPhoneOutput } from '../../types/CommonTypes'
import { createRequiredFieldValidator, createEmailFieldValidator, createNameFieldValidator } from '../../validators/StringValidator.ts'
import {
  getContactDetails,
  UpdateAddressBook,
  getContactOrders,
  getContactInformation,
  UpdateAddressBookInfo,
  getContactSocials,
  UpdateAddressBookSocials,
  getContactNotes,
  UpdateAddressBookNotes,
  FindAddressBook
} from '../../api/AddressBook'
import AddressControl from '../PWS/AddressControl.vue'
import PhoneInputControl from '../PhoneInputControl.vue'
import { GetCountryCode, GetEventManagementUrl, GetOrderReceiptUrl, GetCultureName, GetContactOrderEntryUrl } from '../../stores/SettingsStore'
import { resolveColumnWidth } from '../../utils/kendoHelper.ts'
import { Checkbox as KCheckBox,  type CheckboxChangeEvent  } from '@progress/kendo-vue-inputs'
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import { GetCountriesFromLocalStorageOrApi, GetCodesFromLocalStorageOrApi, GetCulturesFromLocalStorageOrApi } from '../../services/CountryCultureService'
import {SetIsLoading} from '../../services/AoeHelpers.ts'
import { ContactCustomerCreate } from '../../api/Customer'
import { handleError } from '../../services/ErrorService.ts'
import { orderBy } from '@progress/kendo-data-query';
import type { SortDescriptor } from '@progress/kendo-data-query'
import { formatDate, formatDateForJSONRequest } from '../../api/Common.ts'
import { FormatCurrency } from '../../services/currencyFormatter'
import { DatePicker, type DatePickerChangeEvent } from '@progress/kendo-vue-dateinputs';
import { LocalizationProvider } from '@progress/kendo-vue-intl';
import { TextArea } from "@progress/kendo-vue-inputs";
import { useDatePickerLocalization } from '../../composables/useDatePickerLocalization'
import { PwsLeadGetList } from '../../api/Lead'
import { type ILeadItem } from '../../types/LeadTypes'
import Swal from 'sweetalert2'
const { t, locale } = useI18n()
const logger = useLogger()
const { dateFormat, formatPlaceholder } = useDatePickerLocalization(locale)
interface DLLOption {
  text: string
  id: string
}
interface ContactEdit extends IAoeContact {
  billingFirstName?: string | null
  billingLastName?: string | null
  shippingSameAsBilling?: boolean
}
// Use any type for the editor reference to avoid TypeScript errors
const editorRef = ref<string>('');
const eventManagementURL = ref<string>('')
const finalOrderSummaryURL = ref<string>('')
const loader = ref<boolean>(false)
const sort = ref<SortDescriptor[]>([{ field: 'eventStartDate', dir: 'desc' }])
const orderGridData = ref<IAoeContactOrder[]>([])
const sortedGridData = computed<IAoeContactOrder[]>(() => orderBy(orderGridData.value, sort.value));

function getEventDisplayText(order: IAoeContactOrder): string {
  return `${order.eventId} - ${order.eventTitle}`
}

const columns = [
        {
          field: 'orderId',
          title: t('consultantCorner.editContact.OrderId'),
          cell: 'orderIdTemplate',
          width: resolveColumnWidth('100px', t('consultantCorner.editContact.OrderId'))
        },
        {
          field: 'orderTime',
          title: t('consultantCorner.editContact.OrderTime'),
          cell: 'orderDateTemplate',
          width: resolveColumnWidth('100px', t('consultantCorner.editContact.OrderTime'))
        },
        {
          field: 'orderStatus',
          title: t('consultantCorner.editContact.OrderStatus'),
          width: resolveColumnWidth('120px', t('consultantCorner.editContact.OrderStatus'))
        },
        {
          field: 'orderTotal',
          title: t('consultantCorner.editContact.OrderTotal'),
          cell: 'orderTotalTemplate',
          width: resolveColumnWidth('120px', t('consultantCorner.editContact.OrderTotal'))
        },
        {
          field: 'hostName',
          title: t('consultantCorner.editContact.HostName'),
          width: resolveColumnWidth('150px', t('consultantCorner.editContact.HostName'))
        },
        {
          field: 'eventDate',
          title: t('consultantCorner.editContact.EventDate'),
          cell: 'eventDateTemplate',
          width: resolveColumnWidth('100px', t('consultantCorner.editContact.EventDate'))
        },
        {
          field: 'eventId',
          title: t('eventList.EventId'),
          cell: 'eventIdTemplate',
          width: resolveColumnWidth('100px', t('eventList.EventId'))
        }
      ]
  function sortChangeHandler (e: GridSortChangeEvent) {
  loader.value = true;
  if (e.sort[0] !== undefined) {
    sort.value = e.sort;
  }
  else
  {
    logger.debug('sortChangeHandler: e.sort[0] is undefined')
  }
  loader.value = false;
}
// Function to create a new order for this contact
async function createOrder() {
  try {
    const urlParams = new URLSearchParams(window.location.search)
    const contactId = urlParams.get('contact')

    if (!contactEmail.value) {
      logger.error('No email address available for contact')
      Swal.fire({ text: t('alerts.NoEmailForContact'), icon: 'error' })
      return
    }

    let beeNumberForOrder = contactBeeNumber.value

    if (!beeNumberForOrder) {
      SetIsLoading(true)
      logger.info('Creating customer account for contact')

      let customerAlreadyExists = false
      try {
        const customerResponse = await ContactCustomerCreate({
          firstName: formInitialValues.value.firstName,
          lastName: formInitialValues.value.lastName,
          emailAddress: formInitialValues.value.emailAddress,
          primaryPhone: primaryPhoneModel.value ? {
            number: primaryPhoneModel.value.number || '',
            countryCode: primaryPhoneModel.value.countryCode || countryCode.value,
            codeIdPhoneType: primaryPhoneModel.value.codeIdPhoneType || 'MOBILE'
          } : undefined,
          countryCode: countryCode.value,
          classId: 'CUSTOMER'
        })

        if (customerResponse.beeNumber) {
          beeNumberForOrder = customerResponse.beeNumber
          contactBeeNumber.value = customerResponse.beeNumber
          logger.info('Customer account created with beeNumber:', beeNumberForOrder)
        } else {
          SetIsLoading(false)
          logger.error('Failed to create customer account:', customerResponse.responseStatus)
          Swal.fire({ text: t('alerts.CustomerCreateFailed'), icon: 'error' })
          return
        }
      } catch (createError: unknown) {
        // Check if customer already exists with this email
        // Error code can be in responseStatus (direct) or response.data.responseStatus (axios)
        const axiosError = createError as { response?: { data?: { responseStatus?: { errorCode?: string } } }, responseStatus?: { errorCode?: string } }
        const errorCode = axiosError?.response?.data?.responseStatus?.errorCode || axiosError?.responseStatus?.errorCode
        if (errorCode === 'BeeCommunicationDuplicateEmailAddressException') {
          logger.info('Customer already exists with this email, will link via UpdateAddressBook')
          customerAlreadyExists = true
        } else {
          throw createError
        }
      }

      // Update address book to link with customer account (new or existing)
      const hasValidShipping = formInitialValues.value.shippingAddress?.addressLine1
      const hasValidBilling = formInitialValues.value.billingAddress?.addressLine1

      const addressBookResponse = await UpdateAddressBook({
        addressBookId: formInitialValues.value.addressBookId,
        firstName: formInitialValues.value.firstName,
        lastName: formInitialValues.value.lastName,
        emailAddress: formInitialValues.value.emailAddress,
        primaryPhone: primaryPhoneModel.value
          ? { number: primaryPhoneModel.value.number, countryCode: primaryPhoneModel.value.countryCode, codeIdPhoneType: primaryPhoneModel.value.codeIdPhoneType }
          : { number: '', countryCode: countryCode.value, codeIdPhoneType: 'MOBILE' },
        shippingAddress: hasValidShipping ? formInitialValues.value.shippingAddress : null,
        billingAddress: hasValidBilling ? formInitialValues.value.billingAddress : null,
      })
      logger.info('Address book updated with customer link')

      // If customer already existed, get the beeNumber from the updated address book response
      if (customerAlreadyExists && addressBookResponse.beeNumberCustomer) {
        beeNumberForOrder = addressBookResponse.beeNumberCustomer
        contactBeeNumber.value = addressBookResponse.beeNumberCustomer
        logger.info('Linked to existing customer with beeNumber:', beeNumberForOrder)
      }

      SetIsLoading(false)
    }

    const orderEntryUrl = await GetContactOrderEntryUrl()
    const queryParams = new URLSearchParams()

    if (beeNumberForOrder) {
      queryParams.append('contactBeeNumber', beeNumberForOrder.toString())
    }

    if (contactId) {
      queryParams.append('contact', contactId)
    }

    const urlWithParams = `${orderEntryUrl}?${queryParams.toString()}`
    logger.info('Redirecting to order entry URL:', urlWithParams)
    window.location.href = urlWithParams
  } catch (error) {
    SetIsLoading(false)
    logger.error('Error creating order:', error)
    await handleError(error, t)
  }
}
function addNotes() {
    const urlParams = new URLSearchParams(window.location.search)
    const qsAddressBookId = urlParams.get('contact')
      if (editorRef.value && editorRef.value.length > 0) {
        // Call the API to add a new note
        UpdateAddressBookNotes({ addressBookId: Number(qsAddressBookId), noteText: editorRef.value })
          .then(() => {
            editorRef.value = ''
            getNotes(Number(qsAddressBookId))
          })
          .catch(async (error) => {
            logger.error('Error adding notes:', error)
            await handleError(error, t)
          })
      }
}
const formInitialValues = ref<ContactEdit>({ } as ContactEdit)
const addInfoFormInitialValues = ref<IAoeContactInfo>({ } as IAoeContactInfo)
const socialMediaFormInitialValues = ref<IAoeContactSocials>({ } as IAoeContactSocials)

const firstNameValidator = [createRequiredFieldValidator(t, 'firstName'), createNameFieldValidator(t, 'firstName')]
const lastNameValidator = [createRequiredFieldValidator(t, 'lastName'), createNameFieldValidator(t, 'lastName')]
const { loadConsultantEmailAddress, createConsultantOwnEmailValidator } = useConsultantOwnEmailGuard()
const emailValidator = [createRequiredFieldValidator(t, 'emailAddress'), createEmailFieldValidator(t, 'emailAddress'), createConsultantOwnEmailValidator()]
const hasNoEmail = ref(false)
const txtBirthDate = ref<Date | undefined>(undefined)
const selectedTab = ref(0)
const countries= ref<DLLOption[]>([])
const primaryPhoneModel = ref<IPhoneOutput | null>(null)
const primaryPhoneControl = ref<InstanceType<typeof PhoneInputControl> | null>(null)
const alt1PhoneModel = ref<IPhoneOutput | null>(null)
const alt2PhoneModel = ref<IPhoneOutput | null>(null)
const languages = ref<DLLOption[]>([])
const selectedLanguage = ref<DLLOption>({ text: '', id: '' })
const groups = ref<DLLOption[]>([])
const selectedGroup = ref<DLLOption>({ text: '', id: '' })
const referralSources = ref<DLLOption[]>([])
const selectedReferralSource = ref<DLLOption>({ text: '', id: '' })
const addressBookNotes = ref<IAoeContactNote[]>([])
const leads = ref<ILeadItem[]>([])
const isLoadingLeads = ref<boolean>(false)
const leadError = ref<boolean>(false)
const contactEmail = ref<string>('')
const contactBeeNumber = ref<number | null>(null)
const tabs = [
  {
    title: t('consultantCorner.editContact.General'),
    content: 'GeneralContent'
  },
  {
    title: t('consultantCorner.editContact.Lead'),
    name: 'Lead',
    content: 'LeadContent'
  },
  {
    title: t('consultantCorner.editContact.Tasks'),
    name: 'Tasks'
  },
  {
    title: t('consultantCorner.editContact.Notes'),
    name: 'Notes',
    content: 'NotesContent'
  },
  {
    title: t('consultantCorner.editContact.Orders'),
    name: 'Orders',
    content: 'OrdersContent'
  },
  {
    title: t('consultantCorner.editContact.Activity'),
    name: 'Activity'
  },
  {
    title: t('consultantCorner.editContact.AdditionalInformation'),
    name: 'AdditionalInfo',
    content: 'AdditionalInformationContent'
  },
  {
    title: t('consultantCorner.editContact.SocialMedia'),
    name: 'SocialMedia',
    content: 'SocialMediaContent'
  }
]
// Handle tab selection
function onSelectHandler(event: TabStripSelectEventArguments) {
  selectedTab.value = event.selected
  if (event.selected === 1) { // Lead tab index
    getLeads(contactEmail.value)
  }
}
// Handle mobile dropdown selection
function onMobileTabChange(event: Event) {
  const target = event.target as HTMLSelectElement
  const index = parseInt(target.value)
  // Update selectedTab to match desktop behavior
  selectedTab.value = index
  if (index === 1) { // Lead tab index
    getLeads(contactEmail.value)
  }
}
// Check if the device is in mobile view
function checkMobileView() {
  isMobileView.value = window.innerWidth < 768
}
function onPrimaryPhoneChange(value: IPhoneOutput) {
  primaryPhoneModel.value = value
}
function onAlt1PhoneChange(value: IPhoneOutput) {
  alt1PhoneModel.value = value
}
function onAlt2PhoneChange(value: IPhoneOutput) {
  alt2PhoneModel.value = value
}
function dateChangeHandler(event: DatePickerChangeEvent) {
  logger.debug('dateChangeHandler event:', event)
  if (event.value !== null) {
    txtBirthDate.value = event.value
  }
}
function languageChangeHandler(culture: DLLOption) {
  logger.debug('languageChangeHandler')
  selectedLanguage.value = culture
}
function groupChangeHandler(group: DLLOption) {
  logger.debug('groupChangeHandler')
  selectedGroup.value = group
}
function referralSourceChangeHandler(referralSource: DLLOption) {
  logger.debug('referralSourceChangeHandler')
  selectedReferralSource.value = referralSource
}
const myFormGeneral = ref<typeof kForm | null>(null)
const showError = ref<boolean>(false)
onMounted(async () => {
  await loadConsultantEmailAddress()

  const urlParams = new URLSearchParams(window.location.search)
  const qsAddressBookId = urlParams.get('contact')
  if (!qsAddressBookId) {
    showError.value = true
    return
  }
  const cultureName = await GetCultureName()
  GetEventManagementUrl().then(url =>
  {
    eventManagementURL.value = url + "?event="
  })
  finalOrderSummaryURL.value = await GetOrderReceiptUrl()
  const defaultCountryCode = await GetCountryCode()
  GetCulturesFromLocalStorageOrApi().then((data) => {
    if (data) {
      for (const culture of data) {
        languages.value.push({ text: culture.localizedName, id: culture.cultureName })
      }
      selectedLanguage.value = languages.value.find(c => c.id === cultureName) || languages.value[0]
    }
  })
  GetCountriesFromLocalStorageOrApi().then((data) => {
    if (data?.items) {
      for (const country of data?.items) {
        countries.value.push({ text: country.countryCode, id: country.countryCode })
      }
      countries.value.sort((a, b) => {
        return a.text.localeCompare(b.text)
      })
    }
  })
  GetCodesFromLocalStorageOrApi('AddressBookGroup').then(data => {
    if (data)
    {
      for (const codes of data.items) {
        groups.value.push({ text: codes.codeText, id: codes.codeId })
      }
    }
  }).catch(async error => {
    await handleError(error, t)
  })
  GetCodesFromLocalStorageOrApi('SFALEADSOURCE').then(data => {
    if (data)
    {
      for (const codes of data.items) {
        referralSources.value.push({ text: codes.codeText, id: codes.codeId })
      }
    }
  }).catch(async error => {
    await handleError(error, t)
  })
  SetIsLoading(true)
  await GetInfoFormValues(Number(qsAddressBookId),defaultCountryCode)
  await GetAdditionalInfoFormValues(Number(qsAddressBookId))
  await GetSocialMediaFormValues(Number(qsAddressBookId))
  await getNotes(Number(qsAddressBookId))
  await GetBeeNumber()
  SetIsLoading(false)
})
async function GetBeeNumber() {
    const response = await FindAddressBook({ searchText: contactEmail.value })
    if (response && response.items && response.items.length > 0) {
      const addressBookEntry = response.items[0]
      logger.debug('Address book entry found:', addressBookEntry)
      // Get the contactBeeNumber from the response
       contactBeeNumber.value = addressBookEntry.contactBeeNumber
    } else {
      logger.error('No address book entry found for email:', contactEmail.value)
      Swal.fire({ text: t('alerts.NoAddressBookEntryForContact'), icon: 'error' })
    }
}
async function getNotes(addressBookId: number) {
  const notes = await getContactNotes(addressBookId)
  addressBookNotes.value = notes.notes
}
async function GetInfoFormValues(addressbookId: number, defaultCountryCode: string)
{
  getContactDetails(addressbookId).then(data => {
    formInitialValues.value = data
    contactEmail.value = formInitialValues.value.emailAddress
    countryCode.value = formInitialValues.value.shippingAddress.countryCode
    addressFirstNameText.value = formInitialValues.value.shippingAddress.firstName != null ? formInitialValues.value.shippingAddress.firstName : ''
    addressLastNameText.value = formInitialValues.value.shippingAddress.lastName != null ? formInitialValues.value.shippingAddress.lastName : ''
    addressLine1Text.value = formInitialValues.value.shippingAddress.addressLine1
    addressLine2Text.value = formInitialValues.value.shippingAddress.addressLine2 != null ? formInitialValues.value.shippingAddress.addressLine2 : ''
    houseNumberText.value = formInitialValues.value.shippingAddress.houseNumber != null ? formInitialValues.value.shippingAddress.houseNumber : ''
    cityText.value = formInitialValues.value.shippingAddress.city
    stateText.value = formInitialValues.value.shippingAddress.stateCode
    postalCodeText.value = formInitialValues.value.shippingAddress.postalCode
    addressBookShippingAddress.value = formInitialValues.value.shippingAddress
    addressBookBillingAddress.value = formInitialValues.value.billingAddress
    billingCountryCode.value = formInitialValues.value.billingAddress.countryCode
    formInitialValues.value.billingFirstName = formInitialValues.value.billingAddress.firstName
    formInitialValues.value.billingLastName = formInitialValues.value.billingAddress.lastName
    billingFirstNameRef.value = formInitialValues.value.billingAddress.firstName != null ? formInitialValues.value.billingAddress.firstName : ''
    billingLastNameRef.value = formInitialValues.value.billingAddress.lastName != null ? formInitialValues.value.billingAddress.lastName : ''
    billingAddressLine1Text.value = formInitialValues.value.billingAddress.addressLine1
    billingAddressLine2Text.value = formInitialValues.value.billingAddress.addressLine2 != null ? formInitialValues.value.billingAddress.addressLine2 : ''
    billingHouseNumberText.value = formInitialValues.value.billingAddress.houseNumber != null ? formInitialValues.value.billingAddress.houseNumber : ''
    billingCityText.value = formInitialValues.value.billingAddress.city
    billingStateText.value = formInitialValues.value.billingAddress.stateCode
    billingPostalCodeText.value = formInitialValues.value.billingAddress.postalCode
    if (countryCode.value == null)
    {
      countryCode.value = defaultCountryCode
    }
    if (billingCountryCode.value == null)
    {
      billingCountryCode.value = defaultCountryCode
    }
    sameAsShipping.value = formInitialValues.value.shippingAddress.addressId == formInitialValues.value.billingAddress.addressId
    // Populate PhoneInputControl models from API response
    if (formInitialValues.value.primaryPhone) {
      primaryPhoneModel.value = {
        number: formInitialValues.value.primaryPhone.number || '',
        countryCode: formInitialValues.value.primaryPhone.countryCode || defaultCountryCode,
        formattedNumber: formInitialValues.value.primaryPhone.formattedNumber || '',
        codeIdPhoneType: formInitialValues.value.primaryPhone.codeIdPhoneType || '',
        extension: formInitialValues.value.primaryPhone.extension || null
      }
    }
    if (formInitialValues.value.altPhone1) {
      alt1PhoneModel.value = {
        number: formInitialValues.value.altPhone1.number || '',
        countryCode: formInitialValues.value.altPhone1.countryCode || defaultCountryCode,
        formattedNumber: formInitialValues.value.altPhone1.formattedNumber || '',
        codeIdPhoneType: formInitialValues.value.altPhone1.codeIdPhoneType || '',
        extension: formInitialValues.value.altPhone1.extension || null
      }
    }
    if (formInitialValues.value.altPhone2) {
      alt2PhoneModel.value = {
        number: formInitialValues.value.altPhone2.number || '',
        countryCode: formInitialValues.value.altPhone2.countryCode || defaultCountryCode,
        formattedNumber: formInitialValues.value.altPhone2.formattedNumber || '',
        codeIdPhoneType: formInitialValues.value.altPhone2.codeIdPhoneType || '',
        extension: formInitialValues.value.altPhone2.extension || null
      }
    }
  }).catch(error => {
    logger.error('Error loading contact details:', error)
    SetIsLoading(false)
    showError.value = true
  })
}
async function GetSocialMediaFormValues(addressbookId: number) {
  socialMediaFormInitialValues.value = await getContactSocials(addressbookId)
}
async function GetAdditionalInfoFormValues(addressbookId: number) {
  addInfoFormInitialValues.value = await getContactInformation(addressbookId)
  const contactLanguage = languages.value.find(x => x.id == addInfoFormInitialValues.value.cultureName)
  if (contactLanguage) {
    selectedLanguage.value = contactLanguage
  }
  const contactGroup = groups.value.find(x => x.id == addInfoFormInitialValues.value.codeIdAddressBookGroup)
  if (contactGroup) {
    selectedGroup.value = contactGroup
  }
  // Convert birthDate string to Date object if needed
  if (addInfoFormInitialValues.value.birthDate) {
    // Check if it's already a Date object or needs conversion
    if (typeof addInfoFormInitialValues.value.birthDate === 'string') {
      txtBirthDate.value = new Date(addInfoFormInitialValues.value.birthDate)
    } else {
      txtBirthDate.value = addInfoFormInitialValues.value.birthDate
    }
  } else {
    txtBirthDate.value = undefined
  }
}
async function viewOrders() {
  orderGridData.value = []
  loader.value = true;
     const urlParams = new URLSearchParams(window.location.search)
    const qsAddressBookId = urlParams.get('contact')
  SetIsLoading(true)
  getContactOrders(Number(qsAddressBookId)).then((oResp) => {
    if (oResp)
    {
      for (const order of oResp.items) {
          orderGridData.value.push(order)
      }
      loader.value = false;
      SetIsLoading(false)
    }
  }).catch(async error => {
    await handleError(error, t)
  })
}
const sameAsShipping = ref(false)
const shippingAddressControl = ref<InstanceType<typeof AddressControl> | null>(null)
const billingAddressControl = ref<InstanceType<typeof AddressControl> | null>(null)
const addressFirstNameText = ref('')
const addressLastNameText = ref('')
const addressBookShippingAddress = ref<IAddress>()
const addressBookBillingAddress = ref<IAddress>()
const countryCode = ref('')
const addressLine1Text = ref('')
const addressLine2Text = ref<string | null>('')
const houseNumberText = ref<string | null>('')
const cityText = ref('')
const stateText = ref<string | null>('')
const postalCodeText = ref('')
//const verifyAddress = ref<IAddressVerificationListItem[]>([])
const isAddressChange = ref(false)
const billingCountryCode = ref('')
const billingFirstNameRef = ref('')
const billingLastNameRef = ref('')
const billingAddressLine1Text = ref('')
const billingAddressLine2Text = ref<string | null>('')
const billingHouseNumberText = ref<string | null>('')
const billingCityText = ref('')
const billingStateText = ref<string | null>('')
const billingPostalCodeText = ref('')
function sameAsShippingCheckboxHandler(event: CheckboxChangeEvent) {
  sameAsShipping.value = event.value
  formInitialValues.value.billingFirstName = (document.getElementById('firstName') as HTMLInputElement).value
  formInitialValues.value.billingLastName = (document.getElementById('lastName') as HTMLInputElement).value
  SetBillingToShippingAddress()
}
function generateSystemEmail() {
  const randomNumber = Math.floor(100000000 + Math.random() * 900000000)
  return `NoEmail_${randomNumber}@mailinator.com`
}
function noEmailCheckboxHandler(event: CheckboxChangeEvent)
{
  logger.debug('noEmailCheckboxHandler', event)
  hasNoEmail.value = !!event.value

  // Push the change into the reactive form model (not the DOM) so the keyed
  // <kForm :key="JSON.stringify(formInitialValues)"> re-renders the field with
  // the new value. Writing straight to the input's DOM .value, as this used to
  // do, only changed what was visually shown for a moment - Kendo's Field owns
  // the input and redraws it from formInitialValues as soon as the user
  // interacts with it (e.g. on focus), which is why the address appeared to
  // "change back".
  if (hasNoEmail.value) {
    formInitialValues.value.emailAddress = generateSystemEmail()
  } else {
    formInitialValues.value.emailAddress = contactEmail.value || ''
  }
}
function SetBillingToShippingAddress() {
  if (addressBookShippingAddress.value)
  {
    billingAddressControlUpdateHandler(addressBookShippingAddress.value)
  }
}
function addressControlUpdateHandler(data: IAddress)
{
  logger.debug('addressControlUpdateHandler', data)
  addressBookShippingAddress.value = data
  addressBookShippingAddress.value.firstName = (document.getElementById('firstName') as HTMLInputElement)?.value
  addressBookShippingAddress.value.lastName = (document.getElementById('lastName') as HTMLInputElement)?.value
  countryCode.value = data.countryCode
  addressLine1Text.value = data.addressLine1
  addressLine2Text.value = data.addressLine2 != null ? data.addressLine2 : ''
  houseNumberText.value = data.houseNumber != null ? data.houseNumber : ''
  cityText.value = data.city
  stateText.value = data.stateCode
  postalCodeText.value = data.postalCode
  isAddressChange.value = true
  if (sameAsShipping.value)
  {
    SetBillingToShippingAddress()
  }
}
function billingAddressControlUpdateHandler(data: IAddress)
{
  logger.debug('billingAddressControlUpdateHandler', data)
  addressBookBillingAddress.value = data;
  // (document.getElementById('billingFirstName') as HTMLInputElement).value = data.firstName != null ? data.firstName : '';
  // (document.getElementById('billingLastName') as HTMLInputElement).value = data.lastName != null ? data.lastName : '';
  billingFirstNameRef.value = data.firstName != null ? data.firstName : '';
  billingLastNameRef.value = data.lastName != null ? data.lastName : '';
  billingCountryCode.value = data.countryCode
  billingAddressLine1Text.value = data.addressLine1
  billingAddressLine2Text.value = data.addressLine2 != null ? data.addressLine2 : ''
  billingHouseNumberText.value = data.houseNumber != null ? data.houseNumber : ''
  billingCityText.value = data.city
  billingStateText.value = data.stateCode
  billingPostalCodeText.value = data.postalCode
  isAddressChange.value = true
}
function saveTrigger(event: MouseEvent) {
  logger.debug('event:', event)

  // Pre-validate address and phone before triggering any form submits
  // This prevents Additional Info / Social Media from saving when General tab has errors
  // Validate both addresses up-front so error messages appear on all invalid fields at once
  const shippingValid = shippingAddressControl.value?.validate() ?? true
  const billingValid = sameAsShipping.value ? true : (billingAddressControl.value?.validate() ?? true)

  if (!shippingValid || !billingValid) {
    const message = !shippingValid
      ? t('consultantCorner.editContact.ShippingAddressFieldsRequired')
      : t('consultantCorner.editContact.BillingAddressFieldsRequired')
    Swal.fire({
      text: message,
      icon: 'warning',
      confirmButtonText: t('buttons.Okay'),
      confirmButtonColor: '#1a6e7d',
      scrollbarPadding: false,
      heightAuto: false
    })
    return
  }

  // Validate firstName/lastName/email using their validators
  const firstNameValue = (document.getElementById('firstName') as HTMLInputElement)?.value || ''
  const lastNameValue = (document.getElementById('lastName') as HTMLInputElement)?.value || ''
  const emailValue = (document.getElementById('txtEmailAddress') as HTMLInputElement)?.value || ''

  // Check firstName validation
  for (const validator of firstNameValidator) {
    const error = validator(firstNameValue, () => {}, { name: 'firstName' })
    if (error) {
      Swal.fire({
        text: error,
        icon: 'warning',
        confirmButtonText: t('buttons.Okay'),
        confirmButtonColor: '#1a6e7d',
        scrollbarPadding: false,
        heightAuto: false
      })
      return
    }
  }

  // Check lastName validation
  for (const validator of lastNameValidator) {
    const error = validator(lastNameValue, () => {}, { name: 'lastName' })
    if (error) {
      Swal.fire({
        text: error,
        icon: 'warning',
        confirmButtonText: t('buttons.Okay'),
        confirmButtonColor: '#1a6e7d',
        scrollbarPadding: false,
        heightAuto: false
      })
      return
    }
  }

  // Check email validation
  for (const validator of emailValidator) {
    const error = validator(emailValue, () => {}, { name: 'emailAddress' })
    if (error) {
      Swal.fire({
        text: error,
        icon: 'warning',
        confirmButtonText: t('buttons.Okay'),
        confirmButtonColor: '#1a6e7d',
        scrollbarPadding: false,
        heightAuto: false
      })
      return
    }
  }

  // Validate primary phone
  if (primaryPhoneControl.value && !primaryPhoneControl.value.validate()) {
    Swal.fire({
      text: t('consultantCorner.editContact.PhoneRequired'),
      icon: 'warning',
      confirmButtonText: t('buttons.Okay'),
      confirmButtonColor: '#1a6e7d',
      scrollbarPadding: false,
      heightAuto: false
    })
    return
  }

  document.getElementById('btnSave')?.click()
  document.getElementById('btnSaveAdditional')?.click()
  document.getElementById('btnSaveSocialMedia')?.click()
}
function goBack() {
  window.history.back()
}
function onSubmitClickHandler(event: FormSubmitClickEvent) {
  logger.debug('event:', event)
  performSubmit(event)
}
async function performSubmit(event: FormSubmitClickEvent) {
  logger.debug('event:', event)
  if (selectedTab.value == 0) {
    // Validate Kendo Form fields (firstName, lastName, email)
    if (event.isValid === false) {
      logger.debug('Form is not valid')
      return
    }

    // Validate both addresses up-front so error messages appear on all invalid fields at once
    const shippingValid = shippingAddressControl.value?.validate() ?? true
    const billingValid = sameAsShipping.value ? true : (billingAddressControl.value?.validate() ?? true)

    if (!shippingValid || !billingValid) {
      const message = !shippingValid
        ? t('consultantCorner.editContact.ShippingAddressFieldsRequired')
        : t('consultantCorner.editContact.BillingAddressFieldsRequired')
      Swal.fire({
        text: message,
        icon: 'warning',
        confirmButtonText: t('buttons.Okay'),
        confirmButtonColor: '#1a6e7d',
        scrollbarPadding: false,
        heightAuto: false
      })
      return
    }

    // Validate primary phone number (required + format)
    if (!primaryPhoneModel.value?.number?.trim()) {
      if (primaryPhoneControl.value) primaryPhoneControl.value.validate()
      Swal.fire({
        text: t('consultantCorner.editContact.PhoneRequired'),
        icon: 'warning',
        confirmButtonText: t('buttons.Okay'),
        confirmButtonColor: '#1a6e7d',
        scrollbarPadding: false,
        heightAuto: false
      })
      return
    }

    // Validate phone format (numeric only, proper length)
    if (primaryPhoneControl.value && !primaryPhoneControl.value.validate()) {
      return
    }

    const addressBook: IAoeContactUpdate = event.values as ContactEdit
    addressBook.shippingSameAsBilling = sameAsShipping.value
    // Handle shipping address
    if (addressBookShippingAddress.value) {
      // Create a new object to avoid reference issues
      addressBook.shippingAddress = { ...addressBookShippingAddress.value }
      addressBook.shippingAddress.firstName = addressBook.firstName
      addressBook.shippingAddress.lastName = addressBook.lastName
    }
    // Handle billing address
    if (sameAsShipping.value) {
      addressBook.billingAddress = addressBook.shippingAddress ? { ...addressBook.shippingAddress } : null
    } else if (addressBookBillingAddress.value) {
      // Create a new object to avoid reference issues
      addressBook.billingAddress = { ...addressBookBillingAddress.value }
      addressBook.billingAddress.firstName = (document.getElementById('billingFirstName') as HTMLInputElement)?.value
      addressBook.billingAddress.lastName = (document.getElementById('billingLastName') as HTMLInputElement)?.value
    }
    if (addressBook.billingAddress?.addressLine1 == null || addressBook.billingAddress?.addressLine1.length ==0)
    {
      addressBook.billingAddress = null;
    }
    if (addressBook.shippingAddress?.addressLine1 == null || addressBook.shippingAddress?.addressLine1.length ==0)
    {
      addressBook.shippingAddress = null;
    }
    // Map PhoneInputControl models to IPhoneInput for the API
    if (primaryPhoneModel.value && primaryPhoneModel.value.number) {
      addressBook.primaryPhone = {
        countryCode: primaryPhoneModel.value.countryCode,
        number: primaryPhoneModel.value.number,
        codeIdPhoneType: primaryPhoneModel.value.codeIdPhoneType
      }
    }
    if (alt1PhoneModel.value && alt1PhoneModel.value.number) {
      addressBook.altPhone1 = {
        countryCode: alt1PhoneModel.value.countryCode,
        number: alt1PhoneModel.value.number,
        codeIdPhoneType: alt1PhoneModel.value.codeIdPhoneType
      }
    }
    if (alt2PhoneModel.value && alt2PhoneModel.value.number) {
      addressBook.altPhone2 = {
        countryCode: alt2PhoneModel.value.countryCode,
        number: alt2PhoneModel.value.number,
        codeIdPhoneType: alt2PhoneModel.value.codeIdPhoneType
      }
    }
    logger.error('addressBook:', addressBook)
    SetIsLoading(true)
    try {
      const response = await UpdateAddressBook(addressBook)
      SetIsLoading(false)
      // Show success message
      Swal.fire({
        title: t('consultantCorner.editContact.SaveSuccess'),
        text: t('consultantCorner.editContact.ContactUpdatedSuccessfully'),
        icon: 'success',
        confirmButtonText: t('buttons.Okay'),
        confirmButtonColor: '#1a6e7d',
        scrollbarPadding: false,
        heightAuto: false
      })
      logger.info('Contact saved successfully:', response)
    } catch (error) {
      SetIsLoading(false)
      logger.error('Error saving contact:', error)
      await handleError(error, t, { title: t('consultantCorner.editContact.SaveError'), confirmButtonText: t('buttons.Okay') })
    }
  }
}
function onSubmitInfoClickHandler(event: FormSubmitClickEvent) {
  logger.debug('event:', event)
  performAddInfoSubmit(event)
}
async function performAddInfoSubmit(event: FormSubmitClickEvent) {
  logger.debug('event:', event)
    const addressBook: IAoeContactInfo = event.values as IAoeContactInfo
    addressBook.cultureName = selectedLanguage.value.id
    if (selectedReferralSource.value) {
      addressBook.codeIdHearAboutUs = selectedReferralSource.value.id
    }
    if (selectedGroup.value) {
      addressBook.codeIdAddressBookGroup = selectedGroup.value.id
    }
    if (txtBirthDate.value) {
      addressBook.birthDate = formatDateForJSONRequest(txtBirthDate.value)
    }
    SetIsLoading(true)
    try {
      const response = await UpdateAddressBookInfo(addressBook)
      SetIsLoading(false)
      // Show success message
      Swal.fire({
        title: t('consultantCorner.editContact.SaveSuccess'),
        text: t('consultantCorner.editContact.AdditionalInfoUpdatedSuccessfully'),
        icon: 'success',
        confirmButtonText: t('buttons.Okay'),
        confirmButtonColor: '#1a6e7d',
        scrollbarPadding: false,
        heightAuto: false
      })
      logger.info('Additional info saved successfully:', response)
    } catch (error) {
      SetIsLoading(false)
      logger.error('Error saving additional info:', error)
      await handleError(error, t, { title: t('consultantCorner.editContact.SaveError'), confirmButtonText: t('buttons.Okay') })
    }
}
function onSubmitSocialMediaClickHandler(event: FormSubmitClickEvent) {
  logger.debug('event:', event)
  performSocialsSubmit(event)
}
async function performSocialsSubmit(event: FormSubmitClickEvent) {
  logger.debug('event:', event)
    const addressBook: IAoeContactSocials = event.values as IAoeContactSocials
    SetIsLoading(true)
    try {
      const response = await UpdateAddressBookSocials(addressBook)
      SetIsLoading(false)
      // Show success message
      Swal.fire({
        title: t('consultantCorner.editContact.SaveSuccess'),
        text: t('consultantCorner.editContact.SocialMediaUpdatedSuccessfully'),
        icon: 'success',
        confirmButtonText: t('buttons.Okay'),
        confirmButtonColor: '#1a6e7d',
        scrollbarPadding: false,
        heightAuto: false
      })
      logger.info('Social media saved successfully:', response)
    } catch (error) {
      SetIsLoading(false)
      logger.error('Error saving social media:', error)
      await handleError(error, t, { title: t('consultantCorner.editContact.SaveError'), confirmButtonText: t('buttons.Okay') })
    }
}
async function getLeads(emailAddress?: string) {
  isLoadingLeads.value = true
  leadError.value = false
  try {
    // If we have the contact's email address, use it to filter leads
    const response = await PwsLeadGetList(emailAddress)
    leads.value = response.items || []
  } catch (error) {
    leadError.value = true
    logger.error('Error fetching leads:', error)
  } finally {
    isLoadingLeads.value = false
  }
}
const isMobileView = ref(false)
onBeforeMount(() => {
  // Initial check for mobile view
  checkMobileView()
  // Add event listener for window resize
  window.addEventListener('resize', checkMobileView)
})
</script>
<style lang="scss">
div:where(.swal2-container) {
  height:100vh !important;
}
/* Mobile tab dropdown styling */
.cc-edit-contact {
  .mobile-tab-dropdown {
    display: none;
    margin: $spacing-5 0;
    width: 100%;
  }
  .contact-header {display:flex;
    justify-content: space-between;
  }
  .contact-buttons {
    margin-top:auto;
    button {
      margin-left:10px;
      min-width:90px;
    }
  }
  .cc-back-button {
    border:none;
    background:none;
  }
  .contact-title{
    @include typography-h3;
    @include font-weight-semibold;
    color: var(--text-color);
    margin-bottom: 5px;
  }
  .mobile-tab-dropdown label {
    @include font-weight-medium;
    display: block;
    margin-bottom: 8px;
  }
  .mobile-tab-dropdown select {
    width: 100%;
    padding: $spacing-2-5;
    border-radius: $radius-sm;
    @include typography-body;
    border: 1px solid #e0e0e0;
    background-color: white;
  }
}
@media (max-width: 767px) {
  .cc-edit-contact {
    padding: $spacing-2-5;
  }
  /* Hide desktop tabs and show mobile dropdown on small screens */
  .cc-edit-contact .k-tabstrip-items-wrapper {
    display: none !important;
  }
  .cc-edit-contact .mobile-tab-dropdown {
    display: block !important;
  }
  .form-actions {
    text-align: center;
  }
  .form-actions .btn {
    width: 100%;
    margin-bottom: 0.5rem;
  }
}
.cc-edit-contact{
  .hiddenButton {
    display: none;
  }
  .note-div
  {
    border: 1px solid #cccccc;
    border-radius: $radius-md;
    padding: $spacing-2-5;
    margin: $spacing-2-5;
  }
  .order-buttons
  {
    width: 100%;
    text-align: right;
  }
  .view-orders-btn
  {
    margin-right: 10px;
  }
  .cc-edit-contact .order-grid tr.k-table-row.k-grid-norecords td
  {
    display: none;
  }
  .contact-edit-header {
    @include typography-body;
    @include font-weight-bold;
  }
  .cc-edit-contact {
    padding: $card-padding;
  }
  .cc-edit-contact .k-textbox, .cc-edit-contact .k-dropdownlist
  {
    padding: $spacing-1;
  }
  .cc-edit-contact .k-animation-container
  {
    width: 100%;
  }
  .tab-content-wrapper {
    padding: $spacing-5 0;
  }
  .contact-tabs {
    width: 100%;
  }
  .address-title {
    @include typography-h4;
    @include font-weight-medium;
    margin-bottom: 1rem;
    color: var(--text-color);
  }
  .readonly-field {
    background-color: var(--vt-c-white-soft);
    cursor: not-allowed;
  }
  .contact-details-card {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: white;
    border-radius: $radius-md;
    box-shadow: 0 10px 15px rgba(black, 0.1);
  }
  .contact-details-title {
    @include typography-h4;
    @include font-weight-semibold;
    padding: $spacing-4;
    margin: 0;
    background-color: #f5faf7;
    text-align: left;
    border-bottom: 1px solid #e9ecef;
    border-radius: $radius-md $radius-md 0 0;
  }
  .contact-details-content {
    padding: 0;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: $spacing-5;
  }
  .k-tabstrip-content .k-active{
    padding: 0;
  }
  .contact-details-footer {
    padding: $spacing-4;
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid #e9ecef;
  }
  .form-group {
    margin-bottom: 1rem;
  }
  .form-group label {
    @include font-weight-semibold;
    margin-bottom: 0.5rem;
    display: block;
  }
  .form-control {
    width: 100%;
    padding: 0.5rem;
    @include typography-small;
    border: 1px solid #e0e0e0;
    border-radius: $radius-sm;
  }
  .cc-edit-contact .k-tabstrip .k-item.k-active {
    color:var(--vt-c-teal-dark);
    border-bottom : 2px solid rgba(var(--vt-c-teal-dark), 0.8)!important;
    padding: 0;
    border-left: none;
    border-top: none;
    @include font-weight-bold;
    border-right: none;
    .k-link {
    @include font-weight-bold;
    }
  }
  .form-control:focus {
    border-color: var(--buttonPrimaryColor, #e67e22);
    outline: none;
    box-shadow: 0 0 0 0.2rem rgba(#e67e22, 0.25);
  }
  .form-control.is-invalid {
    border-color: #dc3545;
  }
  .invalid-feedback {
    @include typography-small;
    color: #dc3545;
    margin-top: 0.25rem;
  }
  .form-group label {
    @include font-weight-semibold;
    margin-bottom: 0.5rem;
    display: block;
  }
  .btn-primary-action {
    padding: $spacing-2 $spacing-4;
    border-radius: $radius-sm;
    @include typography-small;
    background-color: var(--buttonPrimaryColor, #e67e22);
    color: white;
    cursor: pointer;
    border: none;
    transition: all 0.2s;
  }
  .btn-primary-action:hover {
    opacity: 0.9;
  }
  .btn-secondary-action {
    padding: $spacing-2 $spacing-4;
    border: 1px solid #e0e0e0;
    border-radius: $radius-sm;
    @include typography-small;
    background-color: white;
    cursor: pointer;
    transition: all 0.2s;
  }
  .btn-secondary-action:hover {
    background-color: var(--vt-c-white-soft);
    border-color: #cccccc;
  }
  .btn {
    @include typography-small;
    padding: 0.5rem 1rem;
    border-radius: $radius-sm;
    cursor: pointer;
  }
  .btn-primary {
    background-color: #e67e22;
    border-color: #e67e22;
    color: white;
  }
  .btn-secondary {
    background-color: #6c757d;
    border-color: #6c757d;
    color: white;
  }
  .btn-cancel {
    background-color: white;
    color: black;
    border: 1px solid black;
  }
  .me-2 {
    margin-right: 0.5rem;
  }
}
@media (max-width: 767px) {
  .cc-edit-contact {
    padding: $spacing-2-5;
  }
  .form-actions {
    text-align: center;
  }
  .form-actions .btn {
    width: 100%;
    margin-bottom: 0.5rem;
  }
}
.cc-edit-contact{
  .k-form-field {margin-top: unset;}
  .k-floating-label{display:none;}
  .k-floating-label-container{padding-top:unset; height: 36px;}
  .namelabel {
    @include font-weight-medium;
    min-width: 120px;
    padding-top: 8px;
  }
  .address-control-wrapper .col-md-3 {
    @include font-weight-medium;
    min-width: 120px;
    padding-top: 8px;
  }
  .address-control-wrapper .row {
    display: flex;
    align-items: center;
  }
  .k-textbox.k-input, .k-dropdownlist {
    height: 38px;
  }
  .address + .address {
    margin-top: 1rem;
  }
  .k-form-field[name="lastName"], .k-form-field[name="billingLastName"] {
    margin-left: $gap-sm;
  }
  .k-form-field[name="emailAddress"] {
    flex: 1;
  }
  .k-focus  .k-textbox.k-input {
    border:2px solid var(--buttonPrimaryColor, #e67e22);
  }
  .phone-label{
    @include font-weight-medium;
    margin-top:.875rem;
  }
  .k-form-field:has(input[id="firstName"]), .k-form-field:has(input[id="lastName"])
  , .k-form-field:has(input[id="billingFirstName"])
  , .k-form-field:has(input[id="billingLastName"]){
    flex: 1;
  }
  .k-form-field:has(input[id="preferredName"]) {
    flex: 1;
  }
  .k-tabstrip-content.k-active{
  border:none;
  }
  .tab-content-wrapper{padding:0px;}
  /* Mobile Responsive Styles */
  @media (max-width: 768px) {
    .namelabel {
      width: 100% !important;
      margin-bottom: 0.5rem;
    }
    .k-form-field[name="lastName"], .k-form-field[name="billingLastName"] {
      margin-left: 0;
      margin-top: 0.5rem;
    }
    .phone-label {
      margin-top: 0.5rem;
      margin-bottom: 0.5rem;
    }
    .contact-buttons {
      flex-direction: column;
      width: 100%;
      gap: 0.5rem;
    }
    .contact-buttons button {
      width: 100%;
    }
    .address {
      margin-bottom: 2rem;
    }
  }
}
</style>
<style lang="scss" scoped>
.address-control-wrapper :deep(.col-md-3) {
  @include font-weight-medium;
  min-width: 120px;
  padding-top: 8px;
}
.address-control-wrapper :deep(.row) {
  display: flex;
  align-items: center;
}
</style>
